import * as Yup from 'yup'

export const groupDaysValidationRules = Yup.object().shape({
  day: Yup.object().required('Week day is required').nullable(),
  start_time: Yup.string().required('Start time is required')
});